import * as React from "react";
import styled from "styled-components";
import { AdHeader } from "./AdHeader";
import { AdMetrics } from "./AdMetrics";
import { AdInformation } from "./AdInformation";
import { AdSystemInfo } from "./AdSystemInfo";
import useBreaksStore from "../../../../store/breaks";
import { BreakItem } from "./types";

interface AdDetailsCardProps {
  onUpdateCurrentBreakAndPosition: (datetime: number) => void;
}

export const AdDetailsCard: React.FC<AdDetailsCardProps> = ({
  onUpdateCurrentBreakAndPosition
}) => {
  const {
    getBreak,
    breaksArray,
    breaks,
    getPosition,
    position,
    setBreak,
    setPosition,
  } = useBreaksStore();

  const [currentIndex, setCurrentIndex] = React.useState(0);
  
  
  const [currentExhibitionsIndex, setCurrentExhibitionsIndex] = React.useState(1);
  
  
  const [currentSequence, setCurrentSequence] = React.useState(0);

  const exhibitions = React.useMemo(() => breaksArray || [], [breaksArray]);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => {
      const newIndex =
        prevIndex < exhibitions.length - 1 ? prevIndex + 1 : prevIndex;
      setBreak(exhibitions[newIndex]); // Usando o índice atualizado
      setPosition(1);
      return newIndex;
    });
    if (getBreak()) {
      const position = getPosition() - 1;
      const podExhibition = getBreak()?.pod.pod_exhibitions[position];
      if (podExhibition) {
        console.log(podExhibition)
        const podExhibitionStartDateTime = new Date(podExhibition?.start_datetime).getTime();
        onUpdateCurrentBreakAndPosition(podExhibitionStartDateTime);
      }
    }
  };

  const handlePrev = () => {
    
    setCurrentIndex((prevIndex) => {
      const newIndex = prevIndex > 0 ? prevIndex - 1 : prevIndex;
      setBreak(exhibitions[newIndex]); // Usando o índice atualizado
      setPosition(1);
      return newIndex;
    });
    if (getBreak()) {
      const position = getPosition() - 1;
      const podExhibition = getBreak()?.pod.pod_exhibitions[position];
      if (podExhibition) {
        console.log(podExhibition)
        const podExhibitionStartDateTime = new Date(podExhibition?.start_datetime).getTime();
        onUpdateCurrentBreakAndPosition(podExhibitionStartDateTime);
      }
    }
  };

  const handleExhibitions = (index: number) => {
    setCurrentExhibitionsIndex(index);
    setCurrentSequence(index + 1);
    //setPosition(index);
    console.log(getBreak());
    if (getBreak()) {
      const position = getPosition() - 1;
      const podExhibition = getBreak()?.pod.pod_exhibitions[position];
      if (podExhibition) {
        const podExhibitionStartDateTime = new Date(podExhibition?.start_datetime).getTime();
        
        onUpdateCurrentBreakAndPosition(podExhibitionStartDateTime);
      }
    }
  };

  React.useEffect(() => {
    const breakItem = getBreak();

    if (!breakItem || !breakItem.id) return;

    const foundIndex = exhibitions.findIndex(
      (item) => item.id === breakItem.id
    );

    if (foundIndex !== -1) {
      setCurrentIndex(foundIndex);
      if (!getPosition()) {
        setPosition(1);
      }
      const podExhibitions =
        exhibitions[foundIndex]?.pod?.pod_exhibitions || [];
      const foundPodIndex = podExhibitions.findIndex(
        (exhibition) => exhibition.position === getPosition()
      );

      if (foundPodIndex !== -1) {
        setCurrentExhibitionsIndex(foundPodIndex);
        setCurrentSequence(foundPodIndex + 1);
        setPosition(foundPodIndex + 1);
      } else {
        setCurrentExhibitionsIndex(0);
        setCurrentSequence(1);
        setPosition(1);
      }
    } else {
      setCurrentIndex(0);
      setCurrentExhibitionsIndex(0);
      setCurrentSequence(1);
      setPosition(1);
    }
  }, [
    getBreak,
    breaks,
    getPosition,
    exhibitions,
    position,
  ]);

  return (
    <CardWrapper>
      {exhibitions.length > 0 ? (
        <CardContainer key={exhibitions[currentIndex]?.id}>
          <AdHeader
            key={exhibitions[currentIndex]?.pod.id}
            id={String(exhibitions[currentIndex]?.pod.index)}
            sequence={currentSequence}
            onNext={handleNext}
            onPrev={handlePrev}
            exhibitions={exhibitions[currentIndex]?.pod.pod_exhibitions.length}
            onExhibitions={handleExhibitions}
          />
          <AdMetrics
            key={exhibitions[currentIndex]?.pod?.index}
            duration={
              (new Date(exhibitions[currentIndex]?.pod.end_datetime).getTime() -
                new Date(
                  exhibitions[currentIndex]?.pod.start_datetime
                ).getTime()) /
              1000
            }
            slate={exhibitions[currentIndex]?.slate?.duration}
          />

          <>
            <AdInformation
              key={`${exhibitions[currentIndex]?.id}-${exhibitions[currentIndex]?.pod?.pod_exhibitions[currentExhibitionsIndex]?.position}`}
              adId={String(
                exhibitions[currentIndex]?.pod.pod_exhibitions[
                  currentExhibitionsIndex
                ]?.creative?.id ?? ""
              )}
              title={
                exhibitions[currentIndex]?.pod.pod_exhibitions[
                  currentExhibitionsIndex
                ]?.creative?.title ?? "Sem título"
              }
              description={
                exhibitions[currentIndex]?.pod.pod_exhibitions[
                  currentExhibitionsIndex
                ]?.creative?.description ?? "Sem descrição"
              }
              adDuration={
                Math.max(1, exhibitions[currentIndex]?.pod?.pod_exhibitions[
                  currentExhibitionsIndex
                ]?.creative?.duration) ?? 0 
              }
            />
            <AdSystemInfo
              key={`${exhibitions[currentIndex]?.id}`}
              systemId={
                exhibitions[currentIndex]?.pod.pod_exhibitions[
                  currentExhibitionsIndex
                ]?.vast_id ?? ""
              }
              systemName={
                exhibitions[currentIndex]?.pod.pod_exhibitions[
                  currentExhibitionsIndex
                ]?.vast_sytem ?? ""
              }
            />
          </>
        </CardContainer>
      ) : (
        <LoadingMessage>Carregando informações</LoadingMessage>
        
      )}
    </CardWrapper>
  );
};

const CardWrapper = styled.div`
  border-radius: 0;
  display: flex;
  /*min-width: 580px;
  width: 580px;*/
  min-width: 580px;
  max-width: 580px;
  width: 100%;
  flex-direction: column;
  
  height: 447px;
`;

const CardContainer = styled.div`
  border-radius: 8px;
  background-color: rgba(243, 243, 243, 1);
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 10px;
  font-family: "Roboto","Montserrat";
  
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const LoadingMessage = styled.div`
  
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  height: 560px;
  font-family: "Roboto","Montserrat";
  font-size: 24px;
  
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;
